/**
 * Default color palette using Tailwind CSS colors at 600 level.
 * These colors are used throughout the application for project colors,
 * color picker components, and other UI elements that need consistent colors.
 */
export const DEFAULT_COLOR_PALETTE = {
  rose: '#e11d48', // rose-600
  pink: '#db2777', // pink-600
  fuchsia: '#c026d3', // fuchsia-600
  purple: '#9333ea', // purple-600
  violet: '#7c3aed', // violet-600
  indigo: '#4f46e5', // indigo-600
  blue: '#2563eb', // blue-600
  sky: '#0284c7', // sky-600
  cyan: '#0891b2', // cyan-600
  teal: '#0d9488', // teal-600
  emerald: '#059669', // emerald-600
  green: '#16a34a', // green-600
  lime: '#65a30d', // lime-600
  yellow: '#ca8a04', // yellow-600
  amber: '#d97706', // amber-600
  orange: '#ea580c', // orange-600
  red: '#dc2626', // red-600
  slate: '#475569', // slate-600
  accent: '#f4f4f5', // accent
} as const;

/**
 * Array of all color values for iteration
 */
export const DEFAULT_COLOR_VALUES = Object.values(DEFAULT_COLOR_PALETTE);

/**
 * Array of all color names for reference
 */
export const DEFAULT_COLOR_NAMES = Object.keys(DEFAULT_COLOR_PALETTE) as Array<
  keyof typeof DEFAULT_COLOR_PALETTE
>;

/**
 * Generate a random color from the default palette
 */
export const generateRandomColor = (): string => {
  const randomIndex = Math.floor(Math.random() * DEFAULT_COLOR_VALUES.length);
  return DEFAULT_COLOR_VALUES[randomIndex];
};

/**
 * Default avatar fallback background color using CSS variable for theme support.
 * Uses the accent color defined in the theme (supports both light and dark modes).
 */
export const AVATAR_FALLBACK_COLOR = 'hsl(var(--accent))';
